import { nativeCommsBroadcastMessageTypes } from "../../../nativeComms";
import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // File Menu
  nativeCommsBroadcastMessageTypes.FILE_SAVE,
  nativeCommsBroadcastMessageTypes.FILE_SAVE_AS,
  nativeCommsMessageTypes.FILE_PRINT,
  nativeCommsMessageTypes.FILE_EXPORT_CSV,
  nativeCommsMessageTypes.FILE_EXPORT_IMAGE,
  nativeCommsMessageTypes.FILE_EXPORT_TSF,
  nativeCommsBroadcastMessageTypes.FILE_IMPORT_CSV,
  nativeCommsMessageTypes.SHOW_SAVE_TEMPLATE_MODAL,
  nativeCommsMessageTypes.STORE_LINKS_AS_ABSOLUTE,
  nativeCommsMessageTypes.STORE_LINKS_AS_RELATIVE,
  // Edit Menu
  nativeCommsMessageTypes.UNDO,
  nativeCommsMessageTypes.REDO,
  nativeCommsMessageTypes.OPEN_SEARCH,
  nativeCommsMessageTypes.OPEN_SEARCH_AND_REPLACE,
  // View Menu
  nativeCommsMessageTypes.SHOW_MINDMAP,
  nativeCommsMessageTypes.SHOW_NEW_MINDMAP,
  nativeCommsMessageTypes.SHOW_TIMELINE,
  nativeCommsMessageTypes.SHOW_SPREADSHEET,
  nativeCommsMessageTypes.SHOW_RELATIONSHIPS,
  nativeCommsMessageTypes.SHOW_SUBWAY,
  nativeCommsMessageTypes.SHOW_NARRATIVE,
  nativeCommsMessageTypes.SHOW_OUTLINE,
  nativeCommsMessageTypes.SHOW_ITEM_LIST,
  nativeCommsMessageTypes.TOGGLE_GLOBAL_FILTER,
  nativeCommsMessageTypes.TOGGLE_LOCAL_FILTER,
  nativeCommsMessageTypes.CLEAR_GLOBAL_FILTER,
  nativeCommsMessageTypes.CLEAR_LOCAL_FILTER,
  nativeCommsMessageTypes.SHOW_CALENDAR_MARKERS,
  nativeCommsMessageTypes.SHOW_SETTINGS,
  nativeCommsMessageTypes.SET_FONT_PERCENTAGE,
  nativeCommsMessageTypes.EXPAND_PARENT_ITEM,
  nativeCommsMessageTypes.COLLAPSE_PARENT_ITEM,
  // View Split Menu
  nativeCommsMessageTypes.SPLIT_VERTICALLY,
  nativeCommsMessageTypes.SPLIT_HORIZONTALLY,
  nativeCommsMessageTypes.ADD_SPLIT_TOP,
  nativeCommsMessageTypes.ADD_SPLIT_BOTTOM,
  nativeCommsMessageTypes.ADD_SPLIT_LEFT,
  nativeCommsMessageTypes.ADD_SPLIT_RIGHT,
  nativeCommsMessageTypes.CLOSE_SPLIT,
  nativeCommsMessageTypes.CLOSE_OTHER_SPLITS,
  // View Inspector Menu
  nativeCommsMessageTypes.TOGGLE_INSPECTOR,
  nativeCommsMessageTypes.SHOW_INSPECTOR_RANGE_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_CONSTRAINTS_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_RELATIONSHIPS_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_PROPERTIES_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_ATTACHMENTS_TAB,
  // Navigate Menu
  nativeCommsMessageTypes.SELECT_ALL,
  nativeCommsMessageTypes.SELECT_FIRST_ITEM,
  nativeCommsMessageTypes.SELECT_PREVIOUS_ITEM,
  nativeCommsMessageTypes.SELECT_NEXT_ITEM,
  nativeCommsMessageTypes.SELECT_LAST_ITEM,
  nativeCommsMessageTypes.SELECT_ALL_BEFORE_CURRENT_SELECTION,
  nativeCommsMessageTypes.SELECT_ALL_AFTER_CURRENT_SELECTION,
  nativeCommsMessageTypes.SELECT_NONE,
  nativeCommsMessageTypes.SWITCH_FOCUS,
  nativeCommsMessageTypes.SCROLL_TO_DATE,
  nativeCommsMessageTypes.SCROLL_TO_SELECTION,
  //nativeCommsMessageTypes.SHOW_BOOKMARKS,
  // Timeline Menu
  nativeCommsMessageTypes.ADD_ITEM,
  nativeCommsMessageTypes.ADD_CALENDAR_MARKER,
  nativeCommsMessageTypes.REMOVE_FROM_VIEW,
  nativeCommsMessageTypes.PERMANENT_DELETE,
  nativeCommsMessageTypes.SHIFT_ITEMS_BY,
  nativeCommsMessageTypes.MAKE_CONSECUTIVE,
  nativeCommsMessageTypes.MAKE_DEPENDENT,
  nativeCommsMessageTypes.REMOVE_DEPENDENCIES,
  nativeCommsMessageTypes.EMBED_IN_NEW_PARENT,
  nativeCommsMessageTypes.EMBED_IN_NARRATIVE_FOLDER,

  // Sync Menu
  nativeCommsMessageTypes.TOGGLE_SYNC_BINDER,
  nativeCommsMessageTypes.OPEN_SYNC_SETTINGS,
  nativeCommsMessageTypes.EXECUTE_SYNC,

  // Help Menu
  nativeCommsMessageTypes.SHOW_TUTORIAL
];
